module.exports = require("child_process");


//////////////////
// WEBPACK FOOTER
// external "child_process"
// module id = 8
// module chunks = 0